import React from 'react';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { Loader } from './styled';

export const AreaLoader = ({
  active, inline, lines, ...rest
}) => {
  const classes = serializeClasses([
    active && 'active',
    inline && 'inline',
  ]);

  return Array.from(
    { length: lines },
    (_, key) => <Loader key={Math.random() * key} {...rest} className={classes} />
  );
};

AreaLoader.propTypes = {
  active: PropTypes.bool,
  inline: PropTypes.bool,
  lines: PropTypes.number
};

AreaLoader.defaultProps = {
  active: true,
  inline: false,
  lines: 1,
};
